import { chargeConstants } from '../../_constants';

export function charges(state = {}, action) {
    switch (action.type) {
        case chargeConstants.CHARGE_FETCHING:
            return {
                ...state,
                chargeFetching: true
            };
        case chargeConstants.CHARGE_FETCHED:
            return {
                ...state,
                chargeFetching: false
            };
        case chargeConstants.GET_CHARGES:
            return {
                ...state,
                charges: action.charges,
            };
        case chargeConstants.GET_CHARGE_BY_ID:
            return {
                ...state,
                charge: action.charge
            };
        case chargeConstants.UPDATE_CHARGE:
            return {
                ...state,
                updating: true
            };
        case chargeConstants.UPDATED_CHARGE:
            return {
                ...state,
                updating: false
            };
        case chargeConstants.SEARCH_CHARGE:
            return {
                ...state,
                charges: action.charges
            };
        case chargeConstants.GET_FULL_CHARGES:
            return {
                ...state,
                charges: action.charges,
                chargesSelection: true
            };
        case chargeConstants.GET_CHARGE_FOR_CREATE_CHARGE:
            return {
                ...state,
                forCreateCharge: action.forCreateCharge
            };
        case chargeConstants.GET_GL:
            return {
                ...state,
                GLData: action.GLData
            };
        case chargeConstants.GET_STRIPPING_STUFFING_SELECTION:
            return {
                ...state,
                StfStrSelection: action.StfStrSelection
            };
        case chargeConstants.GET_MASTER_CHARGE:
            return {
                ...state,
                masterCharge: action.masterCharge
            };
        default:
            return state;
    }
}